<script setup lang="ts">
interface Props {
  icon: string;
  isActive?: boolean;
}

defineProps<Props>();

defineEmits<{ click: [] }>();
</script>

<template>
  <button
    type="button"
    :class="[
      'p-2 rounded-lg w-12 h-12 transition-colors',
      'hover:bg-neutral500-o20',
      'focus-visible-inverse',
      isActive ? 'bg-neutral500-o20' : '',
    ]"
    @click="$emit('click')"
  >
    <i class="text-xl" :class="icon"></i>
  </button>
</template>
